import React, { useState, useMemo } from 'react';
import { useCountries } from './hooks/useCountries';
import CountryTable from './components/CountryTable';
import Filters from './components/Filters';
import Loader from './components/Loader';

function App() {
  const { data, loading, error,fetchCountries } = useCountries();
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState('');
  const [populationFilter, setPopulationFilter] = useState('');

  const filteredCountries = useMemo(() => {
    let filtered = data;

    if (search) {
      filtered = filtered.filter((country) =>
        country.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (populationFilter) {
  filtered = filtered.filter((country) => {
    const pop = country.population;
    if (populationFilter === '<1M') return pop < 1_000_000;
    if (populationFilter === '<5M') return pop < 5_000_000;
    if (populationFilter === '<10M') return pop < 10_000_000;
    return true;
  });
}

    return filtered;
  }, [data, search, populationFilter]);

  const handleShowClick = () => {
    setShow(true);
    fetchCountries();
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex items-center justify-between mb-6">
  <h1 className="text-3xl font-bold">Country Explorer </h1>

  {!show && (
    <button
      className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      onClick={handleShowClick}
    >
      Show All Countries
    </button>
  )}
</div>

        {loading && <Loader />}
      {show && (
        <>
          <Filters
            search={search}
            onSearch={setSearch}
            populationFilter={populationFilter}
            onPopulationFilter={setPopulationFilter}
            onClear={() => {
              setSearch('');
              setPopulationFilter('');
            }}
          />

          {loading && <p className="text-center">Loading countries...</p>}
          {error && <p className="text-center text-red-500">{error}</p>}

          {!loading && <CountryTable countries={filteredCountries} />}
        </>
      )}
    </div>
  );
}

export default App;
